import * as React from "react";
import {
  EditComponent,
  CustomComponentProps,
  CreateComponent,
} from "src/components/common/Component";

export function TaxClassEditComponent(props: CustomComponentProps) {
  const { children } = props;
  return <EditComponent attributes={["name"]} children={children} />;
}

export function TaxClassCreateComponent(props: CustomComponentProps) {
  const { children } = props;
  return <CreateComponent source={"Tax Class"} children={children} />;
}
